import Vue from 'vue'
import router from './../pages/m/router.js'
import Http from './http/index.js'
import {
  getQueryString
} from '../libs/util'
import {
  Loading,
  Message
} from 'element-ui'
// 统一请求路径前缀
let base = '/'
let axios = new Http(base, 30000)
axios.setRequestInterceptors(config => {
  let appToken = localStorage.getItem('userUnifyToken') ? localStorage.getItem('userUnifyToken') : ''
  config.headers.token = appToken
  let kywebInfo = 'channel/unify,osName/web,appName/%e5%bf%ab%e5%ba%94%e5%ae%a2%e7%bd%91%e7%ab%99,appVersion/111,appBuildNumber/xxx,appId/xxx'

  if (!localStorage.getItem('kyWebUnifyInfo')) {
    localStorage.setItem('kyWebUnifyInfo', kywebInfo)
    sessionStorage.setItem('kyWebUnifyInfo', kywebInfo)
  }
  if (!config.headers.kywebInfo) {

    config.headers.kywebInfo = 'channel/unify,osName/web,appName/%e5%bf%ab%e5%ba%94%e5%ae%a2%e7%bd%91%e7%ab%99,appVersion/111,appBuildNumber/xxx,appId/xxx'



  }


  return config

}, err => {
  Message.error(err.message)
  return Promise.resolve(err)
})

// http response 拦截器
axios.setResponseInterceptors(response => {
  const data = response.data

  if (data.meta && data.meta.code == 888) { // 会话超时

    sessionStorage.clear()
    localStorage.clear()
    console.log(router, '-----')
    //2023年11月21日 排查统一身份认证编码两次问题  解 许
    if (getQueryString('authorizeUrl')) {

      console.log(555555555)
      // 方案 2：URL 构造器
      const url = new URL(location.href);
      const prefix = `${url.origin}${url.pathname.split('/m/')[0]}`;

      console.log(prefix);   // https://usp.mxzy.edu.cn/SSO-Portal

      window.location.href = prefix + '/m/index.html#/login?authorizeUrl=' + getQueryString('authorizeUrl')
      // router.push({
      //   path: '/login',
      //   query: {
      //     authorizeUrl: getQueryString('authorizeUrl')
      //   }
      // })
    } else {

      router.push({
        path: '/login',
      })
    }

  }

  return data
}, (err) => {
  // Message.destroy();
  Message.error(err.message)
  return Promise.resolve(err)
})

export const getRequest = axios.getRequest
export const postRequest = axios.postRequest
export const postRequestUrl = axios.postRequestUrl
export const BaseUrl = base